module.exports = __webpack_public_path__ + "img/emo_24.9a6d21ff.png";